import './error-handling';
import './routing';
import { configure } from 'mycorems-app-accounts';

configure({
  roleMode: 'universal',
});
